// import { gsap } from 'gsap';

// function initBt2() {
//   var bt = document.querySelectorAll('.cta-button')[0];
//   var particleCount = 12;
//   var colors = ['#5C260B', '#A6BB48', '#ffc82c', '#F7B2AD'];

//   bt.addEventListener('mouseover', function() {
//     var particles = [];
//     var tl = gsap.timeline();

//     tl.to(bt.querySelectorAll('.button__bg'), { duration: 0.6, scaleX: 1.05 });
//     tl.to(bt.querySelectorAll('.button__bg'), { 
//       duration: 0.9, 
//       scale: 1, 
//       ease: 'elastic.out(1.2, 0.4)' 
//     }, 0.6);

//     for (var i = 0; i < particleCount; i++) {
//       particles.push(document.createElement('span'));
//       bt.appendChild(particles[i]);

//       particles[i].classList.add(i % 2 ? 'left' : 'right');
      
//       var dir = i % 2 ? '-' : '+';
//       var r = i % 2 ? getRandom(-1, 1) * i / 2 : getRandom(-1, 1) * i;
//       var size = i < 2 ? 1 : getRandom(0.4, 0.8);
//       let particle = particles[i]; // Use a closure to reference the current particle

//       gsap.timeline({
//         onComplete: function() {
//           particle.parentNode.removeChild(particle);
//         }
//       })
//       .set(particle, { scale: size })
//       .to(particle, { 
//         duration: 0.6, 
//         x: `${dir}20`, 
//         scaleX: 3, 
//         ease: 'slow(0.1, 0.7, false)' 
//       })
//       .to(particle, { 
//         duration: 0.1, 
//         scale: size, 
//         x: `${dir}=25` 
//       }, '-=0.1')
//       .set(particle, { 
//         backgroundColor: colors[Math.round(getRandom(0, 3))] 
//       }, i >= 2 ? null : null)
//       .to(particle, { 
//         duration: 0.6, 
//         x: `${dir}${getRandom(60, 100)}`, 
//         y: r * 10, 
//         scale: 0.1, 
//         ease: 'power3.out' 
//       })
//       .to(particle, { 
//         duration: 0.2, 
//         opacity: 0, 
//         ease: 'power3.out' 
//       }, '-=0.2');
//     }
//   });
// }

// // Utility function to get a random number within a range



// initBt2();


import { gsapSingleton } from "../gsap";
import $ from 'jquery';
import Component from '../models/Component';

const gsap = gsapSingleton();

export default class Button extends Component {
    constructor(element, context) {
        super(element, context);

        $(() => {
            const bt = this.element[0];
            const particleCount = 12;
            const colors = ['#5C260B', '#A6BB48', '#ffc82c', '#F7B2AD'];

            bt.addEventListener('mouseenter', () => {
                const particles = [];
                const tl = gsap.timeline();

                tl.to(bt, { duration: 0.6, scaleX: 1.05 })
                  .to(bt, { 
                      duration: 0.9, 
                      scale: 1, 
                      ease: 'elastic.out(1.2, 0.4)' 
                  }, 0.6);

                for (let i = 0; i < particleCount; i++) {
                    const particle = document.createElement('span');
                    bt.appendChild(particle);
                    particles.push(particle);

                    particle.classList.add(i % 2 === 0 ? 'left' : 'right');

                    const dir = i % 2 === 0 ? '-' : '+';
                    const r = i % 2 === 0 ? getRandom(-1, 1) * i / 2 : getRandom(-1, 1) * i;
                    const size = i < 2 ? 1 : getRandom(0.4, 0.8);

                    gsap.timeline({
                        onComplete: () => particle.remove()
                    })
                    .set(particle, { scale: size })
                    .to(particle, {
                        duration: 0.6,
                        x: `${dir}20`,
                        scaleX: 3,
                        ease: 'slow(0.1, 0.7, false)'
                    })
                    .to(particle, {
                        duration: 0.1,
                        scale: size,
                        x: `${dir}=25`
                    }, '-=0.1')
                    .set(particle, {
                        backgroundColor: colors[Math.round(getRandom(0, 3))]
                    })
                    .to(particle, {
                        duration: 0.6,
                        x: `${dir}${getRandom(60, 100)}`,
                        y: r * 10,
                        scale: 0.1,
                        ease: 'power3.out'
                    })
                    .to(particle, {
                        duration: 0.2,
                        opacity: 0,
                        ease: 'power3.out'
                    }, '-=0.2');
                }
            });

            function getRandom(min, max) {
                return Math.random() * (max - min) + min;
            }
        });
    }
}
